import type { Favourite, FavouriteChangeDto, FavouriteDto } from "../../services/FavouriteService";
import { widgetUidToField } from "../../fields/fields";

export const toFavourite = (favouriteDto: FavouriteDto): Favourite => {
  const field = widgetUidToField(favouriteDto.widgetUid);
  const changedProps = field.fromDto(changesToRecord(favouriteDto.changes)) as Record<string, unknown>;

  return {
    id: favouriteDto.id,
    name: favouriteDto.name,
    field,
    changedProps,
  };
};

const changesToRecord = (changeDtos: FavouriteChangeDto[]): Record<string, unknown> =>
  changeDtos.reduce((acc: Record<string, unknown>, change: FavouriteChangeDto) => {
    acc[change.propertyKey] = change.value;
    return acc;
  }, {});
